import { useMemo } from 'react';

import { useQuery } from 'react-query';
import styled from 'styled-components';

import { API_URL } from 'api/API';
import getMoonInfoApi from 'api/common/getMoonInfoApi';

const MAX_MOON_AGE = 29.5306;
const MOON_IMAGE_AGES = [
  '180',
  '170',
  '160',
  '150',
  '140',
  '130',
  '120',
  '110',
  '100',
  '090',
  '080',
  '070',
  '060',
  '050',
  // '040',
  '030',
  '020',
  '010',
  '000',
];
const MOON_IMAGE_AGES_LENGTH = MOON_IMAGE_AGES.length - 1;

const Container = styled.div`
  min-width: 74px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

const MoonImageWrapper = styled.div`
  position: relative;
`;

const MoonImage = styled.img`
  width: 20px;
  position: relative;
  z-index: 1;
`;

const BgMoonImage = styled(MoonImage)`
  position: absolute;
`;

const Moon = () => {
  const { data } = useQuery([API_URL.COMMON.GET_MOON_INFO], getMoonInfoApi, {
    refetchInterval: 1000 * 30,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  });

  const moonInfo = useMemo(() => {
    if (!data)
      // return {
      //   age: 19.7,
      //   deg: 0,
      //   index: MOON_IMAGE_AGES.length - 1,
      // };
      return undefined

    const initMoonAgePct = (data.age / MAX_MOON_AGE) * 100;
    const rotateDeg = initMoonAgePct >= 50 ? -90 : 90;
    const moonAgePct = initMoonAgePct >= 50 ? 100 - initMoonAgePct : initMoonAgePct;
    let moonImageIdx = 0;

    const halfImagePct = 50 / MOON_IMAGE_AGES_LENGTH;
    if (moonAgePct < halfImagePct / 2) {
      moonImageIdx = 0;
    } else if (moonAgePct >= 50 - halfImagePct / 2) {
      moonImageIdx = MOON_IMAGE_AGES_LENGTH;
    } else {
      moonImageIdx = Math.floor((moonAgePct - halfImagePct / 2) / halfImagePct) + 1;
    }

    return {
      age: data.age.toFixed(1),
      deg: rotateDeg,
      index: moonImageIdx,
    };
  }, [data]);

  if (!moonInfo) return <Container></Container>

  return (
    <Container>
      <MoonImageWrapper>
        <BgMoonImage src="/assets/now/moon/moon.png" alt="moon" />
        <MoonImage
          style={{ transform: `rotate(${moonInfo.deg}deg)` }}
          src={`/assets/now/moon/mask_${MOON_IMAGE_AGES[moonInfo.index]}.png`}
          alt="moon"
        />
      </MoonImageWrapper>
      <span>{moonInfo.age}</span>
    </Container>
  );
};

export default Moon;
